<script lang="ts">
    import {link, push} from 'svelte-spa-router'
    import active from 'svelte-spa-router/active'
    import {authenticationStatus, cookieName} from "../../store/stores.ts";

    function handleClick(event) {

        const burgerButton = event.currentTarget as HTMLAnchorElement;
        const menu = document.querySelector(".navbar-menu")as HTMLDivElement

        burgerButton.classList.toggle("is-active");
        menu.classList.toggle("is-active")
    }

    function logout() {
        let cookieName_value:string;
        cookieName.subscribe(value => {
            cookieName_value = value;
        });

        //We delete the cookie
        document.cookie = cookieName_value + '=deleted; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

        //We put the property authenticated at false
        let authStatus = {authenticated: false}
        authenticationStatus.set(authStatus)

        //We redirect to the login page
        push('/');

    }
</script>

<nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <div role="button" on:click={handleClick} class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasic">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </div>
    </div>

    <div id="navbarBasic" class="navbar-menu is-flex-desktop is-justify-content-center">
        <div class="is-flex-desktop is-flex-direction-row">
            <a href="/commande/ajout" use:link use:active={{path: '/commande/ajout', className: 'navbar-item--active', inactiveClassName: ''}} class="navbar-item has-text-weight-bold">Nouvelle commande</a>
            <a href="/documentations" use:link use:active={{path: '/documentations', className: 'navbar-item--active', inactiveClassName: ''}} class="navbar-item has-text-weight-bold">Documentations</a>
            <div class="navbar-item has-dropdown is-hoverable">
                <p class="navbar-link has-text-weight-bold">Mon compte</p>
                <div class="navbar-dropdown">
                    <a href="/compte/profil/modification" use:link use:active={{path: '/compte/profil/modification', className: 'navbar-item--active', inactiveClassName: ''}} class="navbar-item has-text-weight-bold">Profil</a>
                    <a href="/compte/commande" use:link use:active={{path: '/compte/commande', className: 'navbar-item--active', inactiveClassName: ''}} class="navbar-item has-text-weight-bold">Mes commandes</a>
                    <hr class="navbar-divider">
                    <p class="navbar-item has-text-weight-bold has-background-danger-light is-clickable" on:click={logout}>Déconnexion</p>
                </div>
            </div>
        </div>
    </div>
</nav>
